import { Link } from "../lib/route";
import { MapPin, ArrowRight } from "lucide-react";
import { SITE, COPY } from "../lib/_data";

export default function ServiceArea() {
  const c = (COPY.home && COPY.home.serviceArea) || {};
  return (
    <section
      data-testid="service-area-section"
      className="bg-[#2c2a29] text-[#f9f6f0] py-20 md:py-28 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <span className="text-xs tracking-[0.24em] uppercase font-bold text-[#c85a3c]" data-testid="service-area-eyebrow">
            {c.eyebrow || "Local coverage"}
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-black leading-[1.05] mt-4" data-testid="service-area-blurb">
            {c.blurb || `${SITE.areasBlurb}.`}
          </h2>
          <p className="mt-6 text-[#c9c2b4] leading-relaxed max-w-md" data-testid="service-area-paragraph">
            {c.paragraph || "Not sure if we cover your ZIP code? Send it over — we'll confirm within the hour and get you scheduled."}
          </p>
          <Link
            to={c.ctaTo || "/contact"}
            data-testid="area-check-availability"
            className="mt-8 inline-flex items-center gap-2 bg-[#c85a3c] hover:bg-[#a64b32] text-[#fffdf9] font-bold px-6 py-3.5 rounded-full transition-all hover:-translate-y-0.5"
          >
            {c.ctaLabel || "Check Availability"}
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="lg:col-span-7">
          <ul className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {SITE.serviceAreas.map((area) => (
              <li
                key={area}
                data-testid={`area-${area.toLowerCase().replace(/\s+/g, "-")}`}
                className="flex items-center gap-3 bg-[#3d3a38] hover:bg-[#4a4744] px-4 py-3.5 rounded-xl text-sm font-semibold transition-colors"
              >
                <MapPin className="w-4 h-4 text-[#c85a3c]" strokeWidth={2.4} />
                {area}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
